// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ElementosDocumentosPdf_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /config/elementos_documentos_pdf/delete
 *
 * Deletes a PDF page element by name.
 */
import { registerContract } from './validate'

export interface ElementosDocumentosPdf_DeleteInput {
name: string
}

registerContract('ElementosDocumentosPdf_DeleteInput', {
  name: { type: 'string',  required: true },
})
